import { css, useTheme } from '@emotion/react'
import React from 'react'
import Card from './Card'
import Typography from './Typography'

function MessageCard({ children }) {
    const theme = useTheme() 
    const mainStyle = css`
        .card {
            background-color: transparent;
            border: none;
        }
    `
    return (
        <div css={mainStyle}>
            <Card
                bordered
                className="message-card"
                borderStyle="square">
                <Typography type="h3" fontSize="1.2rem" align="center" color={theme.colors?.secGray}>{children}</Typography>
            </Card>
        </div>
    )
}

export default MessageCard